import { useEffect, useState } from 'react';

const useLocalStorage = <T>(key: string, initialValue: T): [T, (value: T) => void, () => void] => {
  const [value, setValue] = useState<T>(initialValue);

  useEffect(() => {
    try {
      const localStoredValue = window.localStorage.getItem(key);
      if (localStoredValue) {
        // setting state in effect is safe to do here, we're relying on localStorage
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, react-hooks/set-state-in-effect
        setValue(JSON.parse(localStoredValue));
      }
    } catch (error) {
      console.error('Error reading from localStorage:', error);
    }
  }, [key]);

  const setStoredValue = (newValue: T): void => {
    try {
      window.localStorage.setItem(key, JSON.stringify(newValue));
    } catch (error) {
      console.error('Error setting localStorage value:', error);
    }

    setValue(newValue);
  };

  const removeValue = () => {
    if (typeof window === 'undefined') {
      console.warn(`Tried to remove localStorage ${key} key on server side`);
    } else {
      window.localStorage.removeItem(key);
    }

    setValue(initialValue);
  };

  return [value, setStoredValue, removeValue];
};

export default useLocalStorage;
